import dayjs from 'dayjs';

// Add any plugins you want to use with Day.js
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/en-gb';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.locale('en-gb');
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);

export default dayjs;
